
import { Component, Prop, VModel, Vue } from 'vue-property-decorator';

@Component
export default class RadioSwitch extends Vue {
  @Prop() wrapperClass: string;
  @Prop() options!: Record<string, string>;
  @Prop({ default: () => [] }) labels: string[];
  @Prop({ default: true }) radioButtonShown: boolean;
  @VModel() currentOption: string | number;

  get optionValues(): string[] {
    return Object.values(this.options || {});
  }

  getValueByIndex(index: number): string {
    return Object.values(this.options)[index] || '';
  }

  getLabelByIndex(index: number): string {
    return this.labels[index] || Object.values(this.options)[index] || '';
  }
}
